import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { AdvsService } from 'src/app/services/advs.service';

@Component({
  selector: 'advertisment',
  templateUrl: './advertisment.component.html',
  styleUrls: ['./advertisment.component.scss']
})
export class AdvertismentComponent implements OnInit {

  adv: { num: number, link: string, text: string, name: string ,type:string}

  constructor(private advsService: AdvsService, private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit() {
    this.adv = this.advsService.getRandAdv(true)
    this.changeImage();
  }

  changeImage() {
    let newSrc
    if (this.adv.num == 10)
      newSrc = 'assets/images/advs/' + this.adv.num + '/180_320'+ '_' + Math.floor(Math.random() * 5) +'.'+this.adv.type;
    else
      newSrc = 'assets/images/advs/' + this.adv.num + '/180_320.' + this.adv.type;;
    const imageElement = this.el.nativeElement.querySelector('#card_video');
    this.renderer.setAttribute(imageElement, 'src', newSrc);

  }

  addClick() {
    this.advsService.saveClick(this.adv.name, 'simulatesContent', '')
  }

}
